module.exports = __webpack_public_path__ + "static/media/Tour.8ec2354e.png";